import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Loading } from "../Components/Loading";
import "./Table.css";

const Table2 = (props, number, handleChange, loading) => {
  let columns = [];
  let count = 0;
  let type = "";
  const { SearchBar } = Search;
  switch (number) {
    case 1:
      // User List
      columns = [
        { dataField: "name", text: "Name", sort: true },
        { dataField: "id", text: "ID", sort: true },
        { dataField: "email", text: "Email", sort: true },
        { dataField: "admin", text: "Admin", sort: true },
        { dataField: "role", text: "Role", sort: true }
      ];
      type = "User";
      break;
    case 2:
      // Organisation List
      columns = [
        { dataField: "name", text: "Name", sort: true },
        {
          dataField: "counterNumber",
          text: "#Counters",
          sort: true,
          headerStyle: () => {
            return { width: "10%" };
          }
        },
        { dataField: "id", text: "ID", sort: true },
        {
          dataField: "isActive",
          text: "IsActive",
          sort: true,
          headerStyle: () => {
            return { width: "10%" };
          }
        }
      ];
      type = "Organisation";
      break;
    case 3:
      // Farm List
      columns = [
        { dataField: "name", text: "Name", sort: true },
        { dataField: "id", text: "ID", sort: true },
        { dataField: "email", text: "Email", sort: true },
        {
          dataField: "isActive",
          text: "IsActive",
          sort: true,
          headerStyle: () => {
            return { width: "10%" };
          }
        }
      ];
      type = "Farms";
      break;
    case 4:
      // PopList
      columns = [
        { dataField: "name", text: "Name", sort: true },
        { dataField: "id", text: "ID", sort: true },
        {
          dataField: "isActive",
          text: "IsActive",
          sort: true,
          headerStyle: () => {
            return { width: "10%" };
          }
        }
      ];
      break;
    case 5:
      // Counters
      columns = [
        {
          dataField: "id",
          text: "Id",
          sort: true,
          headerStyle: () => {
            return { width: "10%" };
          }
        },
        { dataField: "product", text: "Product", sort: true },
        { dataField: "name", text: "Pro. Serial", sort: true },
        {
          dataField: "orgId",
          text: "Org. Id",
          sort: true,
          headerStyle: () => {
            return { width: "10%" };
          }
        },
        { dataField: "orgName", text: "Org. Name", sort: true },
        { dataField: "description", text: "Description", sort: true }
      ];
      type = "Counters";
      break;
    case 6:
      // LicenceList
      columns = [
        { dataField: "licence", text: "Licence", sort: true },
        { dataField: "counterID", text: "Counter ID", sort: true, hidden: true },
        { dataField: "createdBy", text: "Created by", sort: true },
        { dataField: "createdDate", text: "Created date", sort: true },
        { dataField: "expireDate", text: "Expire date", sort: true },
        { dataField: "magicNumber", text: "Magic number", sort: true },
        { dataField: "proVersion", text: "Program version", sort: true },
        { dataField: "cameraSerialNumber", text: "Camera serial", sort: true },
        { dataField: "counterType", text: "Counter type", sort: true },
        { dataField: "productType", text: "Product type", sort: true },
        { dataField: "comment", text: "Comment", sort: true }
       
      ];
      type = "Licences";
      break;
    default:
      columns = [];
      break;
  }
  const defaultSorted = [
    {
      dataField: "name", // if dataField is not match to any column you defined, it will be ignored.
      order: "asc" // desc or asc
    }
  ];

  const selectRow = {
    mode: "radio",
    hideSelectColumn: true,
    clickToSelect: true,
    bgColor: "lightgrey"
  };

  const getExpireDate = (expireDate) => {
    if (expireDate === null || expireDate === ""){
      return "never";
    }
    return expireDate;
  }

  const getType = (typeList, licencedTypes, defaultValue) => {
    let types = [];

    if (licencedTypes == null || licencedTypes == "") {
      return defaultValue;
    }
    for (let i = 0; i < typeList.length; i++) {
      if ((licencedTypes & (1 << i)) > 0) {
        types.push(typeList[i]);
      }
    }
    return types.join(", ");
  }






  const getCounterType = (counterTypes, counterDef) => {
  
    if (counterDef && counterDef.length > 1){
      const arr = counterDef.split (';');
      let len = arr.length;

      if (len == 1)
         return  <div> {arr[0]} </div>;
      else if( len == 2)
        return  <div> {arr[0]} <br/> {arr[1]} </div>;
      else if( len == 3)
        return  <div> {arr[0]} <br/> {arr[1]} <br/> {arr[2]}</div>; 
      else 
        return  <div> {arr[0]} <br/> {arr[1]} <br/> {arr[2]} <br/> {arr[3]} </div>; 
   


    }
      
    let counters = ["1 Nano", "1 Micro", "3 Micro", "1 Macro", "4 Macro", "1 Wellboat 1400", "3 Macro", "4 Exel 1200", "1 Wellboat 2100", "1 Exel 1200", "2 Wellboat 2100", "3 Exel 1200", "2 S1400"];
    let defaultValue = "";
    return getType(counters, counterTypes, defaultValue);
  }

  const getProductType = (productTypes) => {
    let products = ["SmartFlow", "Biomass Estimation", "Vakicloud"];
    let defaultValue = "Vakicloud";
    return getType(products, productTypes, defaultValue);
  }

  const products = props.map((obj, index) => {

    

    if (obj.counters) {
      count = obj.counters.items.length;
    }
    let object = {
      number: `${index}`,
      name:
        obj.name ||
        obj.orgName ||
        obj.popName ||
        obj.farmName ||
        obj.counterName,
      //id: `${obj.orgID||obj.id}`,
      id: obj.orgID || obj.id || obj.counterID,
      email: obj.email,
      phoneNumber: obj.phoneNumber,
      address: obj.address,
      admin: obj.admin,
      firstName: obj.firstName,
      lastName: obj.lastName,
      isActive: obj.isActive,
      counterNumber: count,
      product: obj.product,
      orgId: `${obj.organisationId}`,
      orgName: obj.organisationName,
      role: obj.role,
      access: obj.access,
      organisations: obj.organisations,
      description: obj.description,
      counters: obj.counters,
      licence: obj.licence,
      counterID: obj.counterID,
      createdBy: obj.createdBy,
      createdDate: obj.createdDate,
      expireDate: getExpireDate(obj.expireDate),
      magicNumber: obj.magicNumber,
      proVersion: obj.proVersion,
      comment: obj.comment,
      cameraSerialNumber: obj.cameraSerialNumber,
      counterType:  getCounterType(obj.counterType, obj.CounterDef),
      productType: getProductType(obj.productType)

    
    };
    return object;
  });
  //onClick={ () => handleDelete(obj.id) }
  const rowEvents = {
    onClick: (e, row, rowIndex) => {


      handleChange(row);
    }
  };


  return (
    <div>
      {loading ? (
        <div className="tabel-loading">
          <Loading />
        </div>
      ) : (
        <ToolkitProvider keyField="id" data={products} columns={columns} search>
          {props => (
            <div>
              {/* <h5>Search table:</h5> */}
              <hr />
              <SearchBar
                {...props.searchProps}
                className="search-box fontAwesome fa"
                placeholder={`Search ${type}`}
                tableId={`${number}`}
              />

              <div className="admin-veiw-table">
                <BootstrapTable
                  defaultSorted={defaultSorted}
                  {...props.baseProps}
                  rowEvents={rowEvents}
                  selectRow={selectRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      )}
    </div>
  );
};
export default Table2;
